// removed by extract-text-webpack-plugin
module.exports = {"component":"_24xJ00Wj _3vV4dgqW _1uSaxYl4","menu":"K-INT_U7","heading":"_3_OoRi3D","logo":"_3vOwb51c","project_list":"_2Im-9A45","project":"_1rtXjBua","toggle":"_2ZVVZUG3 _1lfjmnJU"};


/*****************
 ** WEBPACK FOOTER
 ** ./special-guest.scss
 ** module id = 10
 ** module chunks = 0
 **/